import { render, staticRenderFns } from "./doctorRegist.vue?vue&type=template&id=f44119c8&scoped=true&"
import script from "./doctorRegist.vue?vue&type=script&lang=js&"
export * from "./doctorRegist.vue?vue&type=script&lang=js&"
import style0 from "./doctorRegist.vue?vue&type=style&index=0&id=f44119c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f44119c8",
  null
  
)

export default component.exports